import "./SellGold.css";
import { Link } from "react-router-dom";

import heroImg from "../assets/neck2.webp";
import img1 from "../assets/goldimages.webp";
import img2 from "../assets/9007.webp";
import img3 from "../assets/sellgold.webp";

export default function SellGold() {
  return (
    <div className="sell-page">

      {/* HERO */}
      <div
        className="hero-section"
        style={{ backgroundImage: `url(${heroImg})` }}
      >
        <div className="overlay"></div>

        {/* ✅ MOVE INSIDE hero-text */}
        <div className="hero-text">
          <h1>SELL YOUR GOLD</h1>
          <p>Get instant cash with best market price</p>

          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <span> › </span>
            <span>Sell Gold</span>
          </div>
        </div>
      </div>

      <div className="top-content">
        <h2>Selling Your Gold in Bangalore?</h2>
        <p>
          Do you have unwanted gold jewelry, coins, or other valuables sitting unused in a drawer? Here at Cash for Gold, a leading gold buyer in Bangalore, we can help you convert them into instant cash! We offer a convenient and secure solution to sell your gold for competitive prices.
        </p>
      </div>

      {/* CARDS */}
      <div className="sell-wrapper">
        <div className="cards-container">

          <div className="gold-card">
            <img src={img1} alt="gold" />
            <h3>What We Buy:</h3>
            <ul>
              <li>Gold Jewelry (Necklaces, rings, earrings, bracelets, bangles, etc.)</li>
              <li>Gold Coins (Sovereigns, bullions, commemorative coins)</li>
              <li>Gold Bars & Other Gold Items</li>
            </ul>
          </div>

          <div className="gold-card">
            <img src={img2} alt="gold" />
            <h3>Why Choose Cash for Gold?</h3>
            <ul>
              <li><strong>Fast & Easy Process:</strong> Same day cash</li>
              <li><strong>Fair Pricing:</strong> Market value</li>
              <li><strong>Trusted Service:</strong> Transparent process</li>
            </ul>
          </div>

          <div className="gold-card">
            <img src={img3} alt="gold" />
            <h3>Selling your gold is simple!</h3>
            <ul>
              <li>Bring your gold items</li>
              <li>We check purity & weight</li>
              <li>Get instant payment</li>
            </ul>
          </div>

        </div>
      </div>

    </div>
  );
}